module.exports = __webpack_public_path__ + "img/back_active2.aaac22c9.png";